// @ vendors
const { APIPost } = require('utilities/APIRequestHelper');
const moment = require('moment');
const get = require('lodash/object/get');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
import { registerDocuments } from 'actions/registerDocuments';
// @ utilities
const { findElementbyId } = require('routes/contractsView/utilities/contractStateHelper');
const { formatDate } = require('utilities/dateHelper');
const { formatPhoneNumber, getGender } = require('routes/contractsView/utilities/formHelper');
const { calculateContract } = require('utilities/ibanHelper');
const { existingJunior } = require('utilities/APIParsingHelper');
import { getKinshipText } from 'utilities/contactCenter/intervenerDataHelper';
// @ constants
const actionTypes = require('constants/actionTypes');
const { OPEN_YOUNG_ACCOUNT_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const {
    DATE_FORMAT_API,
    DEFAULT_COUNTRY,
    DEFAULT_DOCUMENT_TYPE,
    EURO_TEXT,
    JUNIOR_ACCOUNT_ACCOUNT_TYPE,
    JUNIOR_ACCOUNT_ACTIVITY_CODE,
    JUNIOR_ACCOUNT_ANNUAL_INCOME_AMOUNT,
    JUNIOR_ACCOUNT_CAMPANA,
    JUNIOR_ACCOUNT_CANAL_COMERCIALIZACION,
    JUNIOR_ACCOUNT_CIVIL_STATUS,
    JUNIOR_ACCOUNT_CNAE93,
    JUNIOR_ACCOUNT_CNO,
    JUNIOR_ACCOUNT_COD_ESTANDAR_REFERENCIA,
    JUNIOR_ACCOUNT_DEVICE1_ORIGIN,
    JUNIOR_ACCOUNT_DEVICE_TYPE,
    JUNIOR_ACCOUNT_FORMATO_DOMIC,
    JUNIOR_ACCOUNT_GESTOR,
    JUNIOR_ACCOUNT_ID_SUB_PRODUCT,
    JUNIOR_ACCOUNT_IND_EMPLOYEE,
    JUNIOR_ACCOUNT_IND_FISCAL_NO,
    JUNIOR_ACCOUNT_IND_FISCAL_YES,
    JUNIOR_ACCOUNT_IND_PERS_TRABAJA,
    JUNIOR_ACCOUNT_IND_TALONARIO,
    JUNIOR_ACCOUNT_INTERVENTION_TYPE,
    JUNIOR_ACCOUNT_LANGUAGE,
    JUNIOR_ACCOUNT_LEVEL_OF_STUDIES,
    JUNIOR_ACCOUNT_PRODUCT_ID,
    JUNIOR_ACCOUNT_SUB_ACTIVITY_CODE,
    JUNIOR_ACCOUNT_TIPO_DOMIC,
    JUNIOR_ACCOUNT_TIPO_INTERVENCION,
    SPAIN_COUNTRY_CODE
} = require('constants/index');


const setJuniorDataSuccess = (response) => ({
    type: actionTypes.SET_JUNIOR_DATA_SUCCESS,
    payload: {
        documentNumber: response.persona.codigodepersona,
        documentType: response.persona.tipodepersona,
        responseCode: response.codErrorSubRetorno.trim()
    }
});

const setJuniorDataFailure = (response) => ({
    type: actionTypes.SET_JUNIOR_DATA_FAILURE,
    payload: {
        response
    }
});

const hireJuniorAccountSuccess = (response) => {
    const contractNumber = get(response, 'methodResult.cuentaSeleccionada.numerodecontrato');
    const product = get(response, 'methodResult.cuentaSeleccionada.producto');

    response.numeroCuenta = calculateContract(product+contractNumber);

    return {
        type: actionTypes.HIRE_ACCOUNT_SUCCESS,
        payload: {
            response
        }
    }
}

const hireJuniorAccountFailure = (response) => ({
    type: actionTypes.HIRE_CONTRACT_FAILURE,
    payload: {
        response
    }
});

const setJuniorAccountHiringInitiationPoint = (initiationPoint) => ({
    type: actionTypes.SET_JUNIOR_ACCOUNT_HIRING_INITIATION_POINT,
    payload: {
        initiationPoint: initiationPoint
    }
});

const resetJuniorAccountHiringInitiationPoint = () => ({
    type: actionTypes.RESET_JUNIOR_ACCOUNT_HIRING_INITIATION_POINT,
});

const setJuniorAccountConfirmation = (dispatch, data, getState) => {
    const requestData = {
        query: data
    };
    const immContracts = getState().contracts;
    const contractType = immContracts.get('contract_type');
    const termsAndCondHiringData = [immContracts.get('hiring_data_contract').toJS()];

    APIPost(dispatch, apiURLBuilder.getURL('hireJuniorAccount'), requestData)
    .then(response => {
        const operationProcessId = getState().contractualPolling.get('operationProcessId');
        const preContractualOperationProcessId = getState().preContractualPolling.get('operationProcessId');
        const contractNumber = response.methodResult.cuentaSeleccionada.numerodecontrato;
        const product = response.methodResult.cuentaSeleccionada.producto;
        const registerDocumentsData =  {
            query: {
                processes: [
                    {
                        processRelation: "PRECONTRACTUAL",
                        operationProcessId: preContractualOperationProcessId
                    },
                    {
                        processRelation: "CONTRACTUAL",
                        operationProcessId: operationProcessId
                    }
                ],
                productAlias: OPEN_YOUNG_ACCOUNT_PRODUCT_ALIAS,
                contract: contractNumber,
                product: product,
            }
        }
        dispatch(setTermsAndCondsInfo(contractType, termsAndCondHiringData, operationProcessId));
            dispatch(registerDocuments(registerDocumentsData));
            return dispatch(hireJuniorAccountSuccess(response));
        })
        .catch(response => {
            if (response.error) {
                dispatch(hireJuniorAccountFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const hireJuniorAccount = (dispatch, getState, dataToken, existingJuniorData) => {
    const immContracts = getState().contracts;
    const accountId = findElementbyId(immContracts.get('card_details'), 'cta_seleccionada');
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const parsedInterveners = immContracts.get('interveners').map((intervener, index) =>
        ({
            formaIntervencion: JUNIOR_ACCOUNT_INTERVENTION_TYPE,
            numOrdenIntervencion: index + 1,
            numeroPersona: intervener.getIn(['identification', 'code']),
            tipoIntervencion: JUNIOR_ACCOUNT_TIPO_INTERVENCION,
            tipoPersona: intervener.getIn(['identification', 'type']),
            kinship: getKinshipText(intervener.get('relationship')),
        })
    );
    const firstTitular = existingJuniorData || {
        codigodepersona: immContracts.getIn(['juniorData', 'documentNumber']),
        tipodepersona: immContracts.getIn(['juniorData', 'documentType']),
    };

    const data = {
        campana: JUNIOR_ACCOUNT_CAMPANA,
        canalComercializacion: JUNIOR_ACCOUNT_CANAL_COMERCIALIZACION,
        canalOperacion: JUNIOR_ACCOUNT_CANAL_COMERCIALIZACION,
        codEstandarReferencia: JUNIOR_ACCOUNT_COD_ESTANDAR_REFERENCIA,
        codMoneda: immAccount.getIn(['balance', 'currency']),
        cuentaSeleccionada: {
            numerodecontrato: immAccount.get('contractNumber'),
            producto: immAccount.get('product')
        },
        cuentaSeleccionadaCCC: { //This field is deprecated
            digitodecontrol: '00',
            numerodecuenta: '0000000000'
        },
        dataToken: dataToken,
        gestor: JUNIOR_ACCOUNT_GESTOR,
        idProducto: JUNIOR_ACCOUNT_PRODUCT_ID,
        idSubproducto: JUNIOR_ACCOUNT_ID_SUB_PRODUCT,
        idioma: JUNIOR_ACCOUNT_LANGUAGE,
        indTalonario: JUNIOR_ACCOUNT_IND_TALONARIO,
        listaIntervinientes: {
            dato: parsedInterveners
        },
        primerTitular: firstTitular,
        tipoCuenta: JUNIOR_ACCOUNT_ACCOUNT_TYPE
    };

    setJuniorAccountConfirmation(dispatch, data, getState);
};

const setJuniorData = (dispatch, getState, dataToken) => {
    const immCardDetails = getState().contracts.get('card_details');
    const personalDataForm = findElementbyId(immCardDetails, 'junior_form_personal_data');
    const contactDataForm = findElementbyId(immCardDetails, 'junior_form_contact_data');
    const taxDataForm = findElementbyId(immCardDetails, 'junior_form_tax_data');
    const birthCountry = findElementbyId(personalDataForm, 'cmb_pais_nacimiento');
    const birthProvince = birthCountry === DEFAULT_COUNTRY ? findElementbyId(personalDataForm, 'cmb_birth_province') : null;
    const lastName = findElementbyId(personalDataForm, 'input-safe-last-name');
    const secondLastName = findElementbyId(personalDataForm, 'input-safe-second-last-name') || '';
    const indFiscalValue = taxDataForm.getIn(['0', 'value']) === 1 ? JUNIOR_ACCOUNT_IND_FISCAL_YES : JUNIOR_ACCOUNT_IND_FISCAL_NO;
    let taxData = [];
    if (findElementbyId(taxDataForm, 'radio_obligaciones_fiscales')) {
        taxData = findElementbyId(taxDataForm, 'tax-additionalcountries') || [];
    }

    const parsedTaxData = taxData.map((country) =>
        ({
            indMotivoTributacion: country.get('indTipoTributacion'),
            pais: country.get('paisTributacion'),
            tin: {
                codigodocumpersonacorp: country.getIn(['tin', 'codigodocumpersonacorp']),
                tipodocumpersonacorp: DEFAULT_DOCUMENT_TYPE
            }
        })
    );

    const requestData = {
        query: {
            listaOtrosDatosAlta: {
                dato: [{
                    anoIngresos: moment().year(),
                    cnae93: JUNIOR_ACCOUNT_CNAE93,
                    cno: JUNIOR_ACCOUNT_CNO,
                    codActividad: JUNIOR_ACCOUNT_ACTIVITY_CODE,
                    codPostal: findElementbyId(contactDataForm, 'input-safe-codigo-postal'),
                    codProvincia: findElementbyId(contactDataForm, 'cmb_provincia'),
                    codSubActiv: JUNIOR_ACCOUNT_SUB_ACTIVITY_CODE,
                    descActividad: 'Desocupado',
                    descPlaza: findElementbyId(personalDataForm, 'input-birthplace'),
                    dirElectr: {
                        listaDirElect: [{
                            tipoDispositivo1: JUNIOR_ACCOUNT_DEVICE_TYPE,
                            origenDisp1: JUNIOR_ACCOUNT_DEVICE1_ORIGIN,
                            dirElectr1: formatPhoneNumber(SPAIN_COUNTRY_CODE + findElementbyId(contactDataForm, 'input-safe-phone-number')),
                            horaDesde1: '00:00:00',
                            horaHasta1: '23:59:59'
                        }]
                    },
                    documento: {
                        codigodocumpersonacorp: findElementbyId(personalDataForm, 'input-number-documents').toUpperCase(),
                        tipodocumpersonacorp: findElementbyId(personalDataForm, 'cmb_tipo_documento')
                    },
                    estadoCivil: JUNIOR_ACCOUNT_CIVIL_STATUS,
                    fechaNac: formatDate(findElementbyId(personalDataForm, 'date-picker-birthday'), DATE_FORMAT_API),
                    formatoDomic: JUNIOR_ACCOUNT_FORMATO_DOMIC,
                    indPersTrabaja: JUNIOR_ACCOUNT_IND_PERS_TRABAJA,
                    indEmpleado: JUNIOR_ACCOUNT_IND_EMPLOYEE,
                    indFiscal: indFiscalValue,
                    ingAnuales: {
                        importe: JUNIOR_ACCOUNT_ANNUAL_INCOME_AMOUNT,
                        divisa: EURO_TEXT
                    },
                    listaPaisTributacion: {
                        datosTributacion: parsedTaxData
                    },
                    nivelEstudios: JUNIOR_ACCOUNT_LEVEL_OF_STUDIES,
                    nombrePersona: {
                        nombre: findElementbyId(personalDataForm, 'input-safe-name'),
                        partprimerapellido: lastName.substring(0, 6),
                        primerapellido: lastName,
                        partsegundoapellido: secondLastName.substring(0, 6),
                        segundoapellido: secondLastName
                    },
                    nombreVia: findElementbyId(contactDataForm, 'input-safe-nombre-via'),
                    numVia: findElementbyId(contactDataForm, 'input-safe-numero'),
                    paisDomic: DEFAULT_COUNTRY,
                    paisNacim: birthCountry,
                    paisNacionalidad: findElementbyId(personalDataForm, 'cmb_personal_nacionalidad'),
                    paisResid: DEFAULT_COUNTRY,
                    poblacion: findElementbyId(contactDataForm, 'input-safe-poblacion'),
                    provNacim: birthProvince,
                    restoDomicilio: findElementbyId(contactDataForm, 'input-safe-otros-datos'),
                    sexo: getGender(findElementbyId(personalDataForm, 'cmb_sexo')),
                    tipoDomic: JUNIOR_ACCOUNT_TIPO_DOMIC,
                    tipoVia: findElementbyId(contactDataForm, 'cmb_tipo_via')
                }]
            }
        }
    };

    return APIPost(dispatch, apiURLBuilder.getURL('setJuniorAccountData'), requestData)
        .then(response => {
            const data = response.lista.dato[0];
            dispatch(setJuniorDataSuccess(data));
            if (!existingJunior(data.codErrorSubRetorno.trim())) {
                dispatch(hireJuniorAccount(dispatch, getState, dataToken));
            }
        })
        .catch(response => {
            if (response.error) {
                dispatch(setJuniorDataFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const hireAccount = () => (dispatch, getState) => {
    // setJuniorData is called to save a new minor information
    let callback = (dispatch, getState, dataToken) => {
        setJuniorData(dispatch, getState, dataToken)
    };

    const cardDetails = getState().contracts.get('card_details');
    const cardOwner = findElementbyId(cardDetails, 'juniorAccount_cardOwner');

    // If a minor that's already in the system is selected, the account is hired directly
    if (!['new', '0'].includes(cardOwner)) {
        callback = (dispatch, getState, dataToken) => {
            const existingJuniorData = {
                codigodepersona: cardOwner,
                tipodepersona: 'F',
            };
            dispatch(hireJuniorAccount(dispatch, getState, dataToken, existingJuniorData));
        };
    }

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    hireAccount,
    hireJuniorAccount,
    resetJuniorAccountHiringInitiationPoint,
    setJuniorAccountHiringInitiationPoint,
};
